export const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-><;:'"+?/\\{}|[\]!@#$%^&*.])[a-zA-Z0-9-><;:'"+?/\\{}|[\]!@#$%^&*.]{8,20}$/

export const handlePasswordKeyDown = (e) => {
  if (e.keyCode === 32) {
    e.preventDefault()
  }
}
